import { getSearchParam } from "@/utils/location"

export const isStandalone = () => {
  const standaloneParam = getSearchParam("standalone")
  return standaloneParam === "true" || standaloneParam === ""
}

export const STANDALONE_CHECKOUT_ERROR_KEY = "standalone-checkout-error"
